import { CSVLink } from 'react-csv'
import { Box } from '@mui/material'
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined'
import { useTranslation } from 'react-i18next'
import { colors } from '../../const/colors'

// react-csv types are incompatible with the current React version
const CSVLinkComponent = CSVLink as any

const TableCSVLink = ({
  csvHeaders,
  data,
  fileName = 'table-data-export.csv',
  filterDownloadCsvValue,
  filterDownloadCsvKeys,
}: {
  csvHeaders?: { label: string; key: string }[] | string[]
  data: any[]
  fileName?: string
  filterDownloadCsvValue?: string
  filterDownloadCsvKeys?: string
}) => {
  const { t } = useTranslation('table_component')
  const csvFilteredData =
    filterDownloadCsvValue && filterDownloadCsvKeys
      ? data.filter(
          row => row.values[filterDownloadCsvKeys] !== filterDownloadCsvValue,
        )
      : data

  return (
    <CSVLinkComponent
      separator={';'}
      data={csvFilteredData.map((row: any) => row.values)}
      filename={fileName}
      headers={csvHeaders ?? undefined}
      style={{ textDecoration: 'none' }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          height: 48,
          px: '20px',
          borderRadius: colors.radiusPill,
          background: colors.navy,
          color: '#fff',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          userSelect: 'none',
          transition: 'background .15s',
          '&:hover': { background: colors.navyDark },
          ...(data.length === 0 && { opacity: 0.4, pointerEvents: 'none' }),
        }}
      >
        <DownloadIcon sx={{ fontSize: 17 }} />
        {t('download_csv')}
      </Box>
    </CSVLinkComponent>
  )
}

export default TableCSVLink
